export const services = [
  {
    id: 1,
    icon: 'ri-code-s-slash-line',
    title: 'Weby',
    description: 'Moderné, rýchle a konverzne optimalizované webové stránky postavené na najnovších technológiách. Zameriavame sa na výkon, SEO a skvelý používateľský zážitok.',
    tags: ['WordPress', 'Next.js', 'Tailwind'],
    color: 'from-orange-500/20 to-orange-500/5',
    accent: 'text-orange-500',
    startingPrice: 'od 490 €',
    pricingNote: 'jednorazovo',
    pricingCategoryId: 'weby',
  },
  {
    id: 2,
    icon: 'ri-store-2-line',
    title: 'E-shopy',
    description: 'Výkonné e-commerce riešenia, ktoré predávajú. Navrhujeme obchody s dôrazom na konverzie, jednoduchosť a maximálny obrat pre vaše podnikanie.',
    tags: ['Shopify', 'WooCommerce', 'Next.js'],
    color: 'from-emerald-500/20 to-emerald-500/5',
    accent: 'text-emerald-500',
    startingPrice: 'od 790 €',
    pricingNote: 'jednorazovo',
    pricingCategoryId: 'eshopy',
  },
  {
    id: 3,
    icon: 'ri-line-chart-line',
    title: 'Marketing',
    description: 'PPC kampane, SEO stratégie a e-mail marketing, ktoré prinášajú merateľné výsledky. Každý cent vášho rozpočtu pracuje na plný výkon.',
    tags: ['Google Ads', 'Meta Ads', 'SEO'],
    color: 'from-amber-500/20 to-amber-500/5',
    accent: 'text-amber-500',
    startingPrice: 'od 199 €',
    pricingNote: 'mesačne',
    pricingCategoryId: 'marketing',
  },
  {
    id: 4,
    icon: 'ri-instagram-line',
    title: 'Sociálne siete',
    description: 'Komplexná správa sociálnych sietí s originálnym obsahom. Budujeme komunity, zvyšujeme dosah a premieňame sledovateľov na zákazníkov.',
    tags: ['Facebook', 'Instagram', 'LinkedIn'],
    color: 'from-rose-500/20 to-rose-500/5',
    accent: 'text-rose-500',
    startingPrice: 'od 249 €',
    pricingNote: 'mesačne',
    pricingCategoryId: 'socialne',
  },
  {
    id: 5,
    icon: 'ri-server-line',
    title: 'Správa systémov',
    description: 'Spoľahlivý hosting, monitoring a správa webových systémov. Zaistíme, že váš web beží 24/7 bez výpadkov s maximálnou bezpečnosťou.',
    tags: ['AWS', 'Nginx', 'Security'],
    color: 'from-violet-500/20 to-violet-500/5',
    accent: 'text-violet-500',
    startingPrice: 'od 49 €',
    pricingNote: 'mesačne',
    pricingCategoryId: 'sprava',
  },
  {
    id: 6,
    icon: 'ri-database-2-line',
    title: 'Interné systémy & CRM',
    description: 'Vývoj systémov šitých na mieru vašim potrebám. Automatizujeme procesy, zavádzame CRM riešenia a prepájame vaše nástroje do jedného celku.',
    tags: ['CRM', 'ERP', 'Automatizácia'],
    color: 'from-teal-500/20 to-teal-500/5',
    accent: 'text-teal-500',
    startingPrice: 'od 390 €',
    pricingNote: 'jednorazovo',
    pricingCategoryId: 'crm',
  },
];

export const stats = [
  { value: '50+', label: 'Spokojných klientov' },
  { value: '7+', label: 'Rokov skúseností' },
  { value: '100%', label: 'Dedikovanosť' },
  { value: '10+', label: 'Odvetví' },
];
